// IE Polyfill
if(/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
  document.write('<script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/picturefill/3.0.3/picturefill.js"><\/script>');
}

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expand = 1000;
lazySizesConfig.expFactor = 4;

// Lazy loading portfolio projects
require('lazysizes');

var p = require('./site_modules/preloader-module');
p.initSRCImages();
p.initBACKGROUNDImages();
